import { Outlet } from 'react-router'
import { SkipLink } from '@/components/SkipLink/SkipLink'
import { NavigationHeader } from './NavigationHeader'
import './layout.scss'

export function Layout() {
  return (
    <>
      <SkipLink />
      <NavigationHeader />
      <main id="main-content" tabIndex={-1}>
        <Outlet />
      </main>
    </>
  )
}
